var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.TextInput,{attrs:{"value":_setup.formattedValue,"type":"date"},on:{"input":_setup.handleInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }